import React from 'react';

const styles = {
  wrap: {
    padding: '16px',
    background: 'rgba(255, 255, 255, 0.03)',
    borderRadius: '16px',
    border: '1px solid rgba(255, 255, 255, 0.05)',
    marginBottom: '20px',
  },
  labelArea: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  label: {
    fontSize: '13px',
    fontWeight: 500,
    color: 'var(--text-muted)',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
  },
  value: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'var(--accent)',
    fontFamily: 'var(--font-mono)',
  },
  slider: {
    WebkitAppearance: 'none',
    width: '100%',
    height: '6px',
    borderRadius: '5px',
    background: 'rgba(255, 255, 255, 0.1)',
    outline: 'none',
    cursor: 'pointer',
    margin: '10px 0',
  },
  // We'll use inline styles for the track progress bar look
  track: (val) => ({
    width: '100%',
    height: '6px',
    borderRadius: '5px',
    background: `linear-gradient(to right, var(--accent) ${val}%, rgba(255, 255, 255, 0.1) ${val}%)`,
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
  }),
  thumbStyle: `
    input[type=range]::-webkit-slider-thumb {
      -webkit-appearance: none;
      appearance: none;
      width: 18px;
      height: 18px;
      border-radius: 50%;
      background: #fff;
      cursor: pointer;
      border: 3px solid var(--accent);
      box-shadow: 0 0 15px rgba(22, 163, 74, 0.5);
      transition: transform 0.1s ease;
    }
    input[type=range]::-webkit-slider-thumb:hover {
      transform: scale(1.1);
    }
  `
};

export default function QualityBar({ value, onChange }) {
  return (
    <div style={styles.wrap}>
      <style>{styles.thumbStyle}</style>
      <div style={styles.labelArea}>
        <span style={styles.label}>Compression Quality</span>
        <span style={styles.value}>{value}%</span>
      </div>
      <div style={styles.track(value)}>
        <input 
          type="range" 
          min="1" 
          max="100" 
          value={value} 
          onChange={(e) => onChange(parseInt(e.target.value))} 
          style={styles.slider}
        />
      </div>
      <div style={{ ...styles.labelArea, marginTop: '8px', marginBottom: 0 }}>
        <span style={{ ...styles.label, fontSize: '10px' }}>Smaller File</span>
        <span style={{ ...styles.label, fontSize: '10px' }}>Higher Quality</span>
      </div>
    </div>
  );
}
